import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import i18n from 'i18next';
import getBaseTheme from 'styles/getBaseTheme';
import config from 'utils/config';
import createElement from 'tricks/dom/createElement';
import loadScript from 'tricks/browser/http/loadScript';
import { getOpenSansFontDetails } from './mindsetFonts';
import { getMindsetAuthToken } from './getMindsetAuthToken';
import { buildMindsetTheme, buildMindsetTextStyles } from './mindsetTheme';
import { MINDSET_CARD_ID } from '../getAgentElement';
import { MINDSET_SDK3_URL } from './mindsetSdkUrls';
// Cached on first call so concurrent renders (e.g. rapid initialQuestion changes
// while the script is still loading) await the same in-flight load instead of
// re-checking the script tag's existence, which would race ahead of a load that
// hasn't finished yet.
var mindsetSDK3ScriptLoadPromise;
function loadMindsetSDK3Script() {
  if (!mindsetSDK3ScriptLoadPromise) {
    var existingScript = document.querySelector("script[src=\"".concat(MINDSET_SDK3_URL, "\"]"));
    mindsetSDK3ScriptLoadPromise = existingScript ? Promise.resolve() : loadScript(MINDSET_SDK3_URL).catch(function (error) {
      mindsetSDK3ScriptLoadPromise = undefined;
      throw error;
    });
  }
  return mindsetSDK3ScriptLoadPromise;
}
export function renderMindsetSDK3(_x) {
  return _renderMindsetSDK.apply(this, arguments);
}
function _renderMindsetSDK() {
  _renderMindsetSDK = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _parentEl$querySelect;
    var appUid, initialQuestion, agentUid, _ref$containerId, containerId, _ref$agentHeight, agentHeight, parentEl, theme, cardTheme, mindsetCustomEl, _yield$Promise$all, _yield$Promise$all2, fontDetails, mindsetTheme, initData;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          appUid = _ref.appUid, initialQuestion = _ref.initialQuestion, agentUid = _ref.agentUid, _ref$containerId = _ref.containerId, containerId = _ref$containerId === void 0 ? MINDSET_CARD_ID : _ref$containerId, _ref$agentHeight = _ref.agentHeight, agentHeight = _ref$agentHeight === void 0 ? '70vh' : _ref$agentHeight;
          parentEl = document.getElementById(containerId); // The container can be unmounted while a caller's init is in flight (e.g. a
          // desktop-to-mobile resize collapses the dock's panel), and appending to
          // nothing would load the SDK for an agent that can never be shown.
          if (parentEl) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          // Remove any existing mindset agent element to avoid duplicates
          (_parentEl$querySelect = parentEl.querySelector('mindset-agent')) === null || _parentEl$querySelect === void 0 || _parentEl$querySelect.remove();
          theme = getBaseTheme();
          cardTheme = theme.sections.card;
          mindsetCustomEl = createElement('mindset-agent', _objectSpread({
            agentUid: agentUid,
            style: "width: 100%; height: ".concat(agentHeight, "; display: block; background-color: ").concat(cardTheme.background, ";"),
            loadingText: i18n.t('loading')
          }, initialQuestion && {
            initialQuestion: initialQuestion
          }));
          parentEl.appendChild(mindsetCustomEl);

          /** **************************
           * MINDSET SDK INITIALIZATION
           ** **************************/

          // Font details and the SDK3 script are fetched in parallel — both are independent and cached.
          _context.next = 2;
          return Promise.all([getOpenSansFontDetails(), loadMindsetSDK3Script()]);
        case 2:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
          fontDetails = _yield$Promise$all2[0];
          mindsetTheme = buildMindsetTheme(theme);
          initData = {
            fetchAuthentication: getMindsetAuthToken,
            appUid: appUid,
            theme: mindsetTheme,
            customFontTheme: _objectSpread(_objectSpread({
              fontFamily: fontDetails.length > 0 ? 'Open Sans' : 'sans-serif'
            }, fontDetails.length > 0 && {
              fontDetails: fontDetails
            }), {}, {
              textStyles: buildMindsetTextStyles({
                includeBodyLineHeight: true
              })
            })
          };
          if (config.mindsetAgentVoice) {
            initData.enableVoice = 'true';
          }
          if (window.mindset) {
            _context.next = 3;
            break;
          }
          throw new Error('Mindset SDK failed to load');
        case 3:
          _context.next = 4;
          return window.mindset.init(initData);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderMindsetSDK.apply(this, arguments);
}